import * as React from 'react';
import { SchemeType } from '../../../../../../interfaces/merchants/products/purchases';
import Button from '../../../../../common/buttons/Button';
import StringUtils from '../../../../../utils/StringUtils';
import Price from '../../../../common/texts/Price';
import TicketCount from '../../../../common/texts/TicketCount';
import TicketExpiration from '../../../../common/texts/TicketExpiration';

import css from './index.module.scss';

interface Props {
  className?: string;
  name: string;
  schemeType: string;
  price: number;
  ticketCount?: number;
  expiration?: number;
  imageUrl?: string;
  description?: string;
  onClick: () => void;
}

const Detail: React.SFC<Props> = ({
  name,
  schemeType,
  price,
  ticketCount,
  expiration,
  imageUrl,
  description,
  onClick,
}: Props) => {
  const isSubscription = schemeType === SchemeType.Subscription;
  const isTicketBook = schemeType === SchemeType.TicketBook;

  return (
    <div className={css.Index}>
      <div className={css.Index__TitleContainer}>
        <div className={css.Index__Title}>{name}</div>
        <div className={css.Index__Summary}>
          {isTicketBook && (
            <div className={css.Index__SummaryFirst}>
              <TicketCount count={ticketCount!} />
              <TicketExpiration
                className={css.Index__TicketBookExpiration}
                expiration={expiration!}
              />
            </div>
          )}
          <Price
            className={css.Index__Price}
            price={price}
            isMonthly={isSubscription}
          />
          <div className={css.Index__ButtonContainer}>
            <Button onClick={onClick} className={css.Index__Button}>
              購入する
            </Button>
          </div>
        </div>
      </div>
      {imageUrl && (
        <div className={css.Index__CardContainer}>
          <img className={css.Index__Card} src={imageUrl} alt={name} />
        </div>
      )}
      {description && (
        <div className={css.Index__DescriptionContainer}>
          <div className={css.Index__Description}>
            {StringUtils.simpleFormat(description)}
          </div>
        </div>
      )}
    </div>
  );
};

export default Detail;
